var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-5"},[_vm._v(" "+_vm._s(_vm.label)+" "),_c('v-progress-linear',{attrs:{"color":"white","buffer-value":_vm.value,"stream":"","rounded":"","height":"8"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }